import { of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../services/password-request.service";
import * as i2 from "@angular/router";
export class PasswordRequestGuard {
    constructor(passwordRequestService, router) {
        this.passwordRequestService = passwordRequestService;
        this.router = router;
    }
    canActivate(next, state) {
        if (!next.params.token) {
            return of(false);
        }
        return this.passwordRequestService.getPasswordRequest(next.params.token).pipe(switchMap(response => of(true)), catchError(error => {
            this.router.navigate(['']);
            return of(false);
        }));
    }
    canActivateChild(next, state) {
        return true;
    }
    canLoad(route, segments) {
        return true;
    }
}
PasswordRequestGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PasswordRequestGuard_Factory() { return new PasswordRequestGuard(i0.ɵɵinject(i1.PasswordRequestService), i0.ɵɵinject(i2.Router)); }, token: PasswordRequestGuard, providedIn: "root" });
